<div class="dialog-container">
  <div class="accordian-content image-container height-100" id="countyModal">
    <div class="profile-photo-header">
      <button id="mob-focus-CFA" type="button" class="close close-btn" aria-label="close" tabindex="0"
      ></button>
      <button tabindex="0" [disabled]="dialogData.saveBtnDisabled" role="button" aria-label="Send" (click)="dialogData.saveCountiesMobile()" class="send-button">Save</button>
    </div>
    <div>
      <div class="parent-my-list for-county-box">
        <mat-accordion>
          <button tabindex="0" [disabled]="dialogData.saveBtnDisabled" role="button" aria-label="Send" (click)="dialogData.saveCountiesMobile()" class="send-button">Save</button>
          @for (item of dialogData.selectedCountiesMobile; track item; let j = $index) {
            <mat-expansion-panel (opened)="dialogData.setOpened(null,j)"
              (closed)="dialogData.setClosed(null,j)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{item?.countyName}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (location of item.locations; track location; let k = $index) {
                <div class="form-group">
                  <input type="checkbox" (click)="dialogData.addRemoveSelectedCountyLocationMobileForSave($event,item.countyCode,location.id,j)" [checked]="location.isActive" id="locationCheckboxMobileAdd_{{item?.countyCode}}_{{location.id}}">
                  <label for="locationCheckboxMobileAdd_{{item?.countyCode}}_{{location.id}}">{{location.name}}</label>
                </div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
      <p class="add-another text-right" (click)="dialogData.toggleMultiCheckboxDropdownMobile()">ADD ANOTHER +</p>
    </div>
  </div>
</div>


<!-- mobile starts -->
<div class="dialog-container" id="allCountyModal">

  <div id="myDropdownParentMobile" class=" dropdown-content-parent-mobile ">
    <div id="myDropdownMobile" class="dropdown-content-mobile ">

      <div class="rectangle-3"></div>
      <input sanitizeInput type="text" tabindex="0" [(ngModel)]="dialogData.searchCountyForMobile" placeholder="Search.." id="myInputMobile" (keyup)="dialogData.filterFunctionForMobile()">
      <button data-dismiss="modal" tabindex="0" class="search-close-button" (keypress)="dialogData.closeCountyModel()"
      (click)="dialogData.closeCountyModel()"></button>

      <div id="mydropdownoptionMobile" class="form-group__field accordian-container ">
        <mat-accordion>
          @for (county of dialogData.countyList | countiesFilter : 'countyName':dialogData.searchCountyForMobile ; track county; let j = $index) {
            <mat-expansion-panel [disabled]="dialogData.disabledArr[j]"  (opened)="dialogData.setOpenedMobile('county', j)"
              (closed)="dialogData.setClosedMobile('county', j)" (click)="dialogData.addRemoveSelectedCountyForMobile($event,'county', j)" (keypress)="dialogData.addRemoveSelectedCountyForMobile($event,'county', j)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{county.countyName}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (location of county.locations; track location; let k = $index) {
                <div class="form-group" id="{{county.countyCode}}_{{location.id}}" >
                  <input type="checkbox"  [(ngModel)]="location.isActive" id="locationCheckboxMobile_{{county.countyCode}}_{{location.id}}" (click)="dialogData.addRemoveSelectedCountyLocationMobile($event,county.countyCode,location.id,j)" name="locationCheckboxMobile_{{county.countyCode}}_{{location.id}}">
                  <label  for="locationCheckboxMobile_{{county.countyCode}}_{{location.id}}" >{{location.name}}</label>
                </div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
      <div class="county-searchbox-buttons">
        <button tabindex="0" class="btn-county blue-county " (click)='dialogData.applyMobile()'>APPLY</button>
        <button tabindex="0" class="btn-county grey-county " [disabled]="dialogData.resetBtnDisabled==false"
        [ngClass]="{'disabled-btn-county' :dialogData.resetBtnDisabled==false}" (click)='dialogData.resetCheckboxes()'>RESET</button>
      </div>
    </div>
  </div>
</div>